import { Step } from 'react-joyride';

const ExpensesTourSteps: Step[] = [
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a <strong>Gastos</strong>. Aquí gestionas todos los gastos de
        tu empresa por mes: puedes <strong>filtrar</strong>,{' '}
        <strong>registrar</strong>, <strong>editar</strong>,{' '}
        <strong>copiar</strong>, <strong>exportar</strong> y{' '}
        <strong>eliminar</strong> gastos, además de revisar recibos y ver el
        total del periodo.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.tour-filters',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Esta zona controla el <strong>periodo</strong> y el{' '}
        <strong>filtro</strong> por categoría:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Mes</strong> y <strong>año</strong>: cambian el listado y
            los totales.
          </li>
          <li>
            <strong>Categoría</strong>: muestra solo los gastos de esa
            categoría.
          </li>
        </ul>
        <br />
        Todo lo que ves debajo se recalcula con estos filtros.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.tour-category-filter',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí eliges la <strong>categoría</strong>. El desplegable se llena con
        las categorías encontradas en el mes seleccionado, para que sea más
        fácil segmentar el gasto.
        <br />
        <br />
        Si eliges “Todas”, verás el listado completo.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },

  {
    target: '.tour-exports',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Estos botones exportan el listado filtrado del periodo:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Excel</strong>: útil para contabilidad y análisis.
          </li>
          <li>
            <strong>PDF</strong>: ideal para informes o para enviar al gestor.
          </li>
        </ul>
        <br />
        La exportación respeta los filtros actuales (mes, año, categoría y
        búsqueda).
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-total-month',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí tienes el <strong>resumen total del mes</strong>.
        <br />
        <br />
        Se desglosa en:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Fijos</strong>: costes recurrentes.
          </li>
          <li>
            <strong>Variables</strong>: costes puntuales o que cambian mes a
            mes.
          </li>
        </ul>
        Esto te permite entender rápidamente el peso de cada tipo de gasto.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-search',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Usa el <strong>buscador</strong> para localizar gastos por{' '}
        <strong>concepto</strong> o <strong>categoría</strong>.
        <br />
        <br />
        La búsqueda se aplica junto con el resto de filtros.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.tour-add-expense',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Pulsa <strong>Añadir gasto</strong> para crear un nuevo registro.
        <br />
        <br />
        Normalmente podrás indicar:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>Concepto y categoría.</li>
          <li>Tipo (fijo o variable).</li>
          <li>Fecha.</li>
          <li>Base imponible, IVA y total.</li>
          <li>Adjuntar recibo (si aplica).</li>
        </ul>
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-sections',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Los gastos se agrupan en <strong>Gastos fijos</strong> y{' '}
        <strong>Gastos variables</strong>.
        <br />
        <br />
        Si una sección no aparece, significa que en ese periodo no hay gastos de
        ese tipo (o que los filtros los han ocultado).
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-table',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el <strong>listado</strong> de gastos del periodo. Cada fila
        muestra los datos clave para revisar rápidamente:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Concepto</strong> y <strong>categoría</strong>.
          </li>
          <li>
            <strong>Fecha</strong>.
          </li>
          <li>
            <strong>Base</strong>, <strong>IVA</strong> y <strong>Total</strong>
            .
          </li>
        </ul>
        <br />
        En escritorio se muestra como tabla (en móvil puede verse en otro
        formato).
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-missing-receipt',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si un gasto aparece marcado como <strong>(sin recibo)</strong>,
        significa que no tiene archivo adjunto.
        <br />
        <br />
        Esto te ayuda a detectar rápidamente qué gastos faltan por documentar.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },

  {
    target: '.tour-row-actions',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En cada gasto tienes acciones rápidas:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Ver recibo</strong>: abre el archivo en una pestaña nueva
            (si existe).
          </li>
          <li>
            <strong>Descargar</strong>: descarga el recibo con nombre
            automático.
          </li>
          <li>
            <strong>Copiar gasto</strong>: crea un gasto nuevo a partir del
            actual.
          </li>
          <li>
            <strong>Editar</strong>: modifica el gasto existente.
          </li>
          <li>
            <strong>Eliminar</strong>: borra el gasto (con confirmación).
          </li>
        </ul>
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-view-receipt',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Con <strong>Ver recibo</strong> abres el archivo asociado para comprobar
        la documentación del gasto.
        <br />
        <br />
        Si no aparece este botón, el gasto no tiene recibo adjunto.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-download-receipt',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Con <strong>Descargar</strong> guardas el recibo en tu equipo.
        <br />
        <br />
        El nombre del archivo se genera a partir del <strong>concepto</strong> y
        la <strong>fecha</strong> para mantenerlo ordenado.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-copy-action',
    content: (
      <div style={{ textAlign: 'justify' }}>
        <strong>Copiar gasto</strong> es útil para gastos recurrentes o
        similares.
        <br />
        <br />
        Copias los datos principales y luego solo ajustas fecha o importes si
        hace falta.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-copy-dialog',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el diálogo de <strong>copiado</strong>. Aquí puedes:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            Elegir la <strong>fecha</strong> del nuevo gasto.
          </li>
          <li>
            Ajustar <strong>base imponible</strong> e <strong>IVA</strong> antes
            de copiar.
          </li>
        </ul>
        <br />
        Importante: el <strong>recibo no se copia</strong>. Si lo necesitas,
        tendrás que adjuntarlo en el gasto nuevo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-copy-confirm',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Al pulsar <strong>Copiar</strong>, se creará un nuevo gasto en la fecha
        seleccionada. Después se actualizará el listado del mes actual.
        <br />
        <br />
        Si quieres copiarlo a otro mes/año distinto, ajusta primero el periodo y
        repite la operación.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-edit-action',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Con <strong>Editar</strong> puedes corregir cualquier dato del gasto:
        concepto, categoría, tipo, fecha o importes.
        <br />
        <br />
        Al guardar, el listado se refresca para reflejar los cambios.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-create-edit-dialog',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este es el formulario de <strong>crear/editar gasto</strong>.
        <br />
        <br />
        Aquí es donde introduces o ajustas toda la información, y si el flujo lo
        permite, también puedes gestionar el <strong>recibo</strong>.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-delete-action',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Con <strong>Eliminar</strong> borrarás el gasto. Antes se te pedirá
        confirmación para evitar borrados accidentales.
        <br />
        <br />
        Tras eliminarlo, el listado y los totales del mes se actualizarán.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  {
    target: '.tour-loading',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Mientras se cargan los datos, verás un estado de{' '}
        <strong>cargando</strong>.
        <br />
        <br />
        Cuando termine, se mostrará el listado con los filtros aplicados.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  {
    target: '.tour-empty',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si ves este mensaje, no hay gastos para el periodo o los filtros
        actuales.
        <br />
        <br />
        Prueba a cambiar el mes/año, quitar filtros o crear un gasto nuevo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  {
    target: '.tour-help-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En cualquier momento puedes pulsar <strong>Ayuda</strong> para repetir
        el tour completo y recordar qué hace cada parte de la pantalla.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
];

export default ExpensesTourSteps;
